// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { xBaseTheme } from "@conklin/XDL/types";
import { color, styledScrollbar } from "@conklin/XDL/Utilities";
import { TabProps } from "@insite/mobius/Tab";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            weight: fontConfig.weight.bold,
            lineHeight: "17px",
        },
        css: css`
            position: relative;
            border-radius: 2px 2px 0 0;
            padding: 6px 12px;
            cursor: pointer;
            color: ${color("common.ui7")};
            &:hover,
            &:focus {
                color: ${color("common.ui1")};
                background-color: ${color("common.ui10")};
            }

            &:focus {
                outline: none;
            }

            ${({ selected }: TabProps) =>
                selected &&
                css`
                    z-index: 1;
                    background-color: ${color("common.ui11")};
                    &,
                    &:focus,
                    &:hover {
                        color: ${color("common.ui1")};
                    }
                `}
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        cssOverrides: {
            tabGroup: css`
                padding: 0;
                position: relative;
                border-bottom: 1px solid ${color("common.border")};
                & > li:not(:last-child) {
                    margin-right: 12px;
                }

                ${styledScrollbar()}
            `,
            tabContent: css`
                position: relative;
                margin-top: 0;
                padding: 12px 0;
                border: 0;
            `,
            wrapper: css`
                width: 100%;
            `,
        },
    },
} as xBaseTheme["tab"];
